"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _reactFiles = _interopRequireDefault(require("react-files"));

var _commonReact = require("@devsta/common-react");

var _BriefBlock = _interopRequireDefault(require("../../../../BriefBlock"));

var _utils = require("../../../../../../../../../common/utils");

require("../styles/_editor-brief-section.scss");

var _Attachment = _interopRequireDefault(require("./Attachment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var EditorBriefSection = /*#__PURE__*/function (_Component) {
  _inherits(EditorBriefSection, _Component);

  var _super = _createSuper(EditorBriefSection);

  function EditorBriefSection(props) {
    var _this;

    _classCallCheck(this, EditorBriefSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onUpdateContent", function (editorState) {
      var onChangeField = _this.props.onChangeField;

      _this.setState({
        editorState: editorState
      });

      var _getContentState = (0, _commonReact.getContentState)(editorState),
          json = _getContentState.json;

      onChangeField('notesToTheEditor')({
        target: {
          value: JSON.stringify(json)
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeFiles", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(files) {
        var _this$props, addFilesToQueue, organisationId, onUpdateAttachments, attachmentAssetIds, assetIds, newIds;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, addFilesToQueue = _this$props.addFilesToQueue, organisationId = _this$props.organisationId, onUpdateAttachments = _this$props.onUpdateAttachments, attachmentAssetIds = _this$props.attachmentAssetIds;

                if (files.length) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _this._files.current.removeFiles();

                _context.next = 6;
                return addFilesToQueue(files.map(function (file) {
                  return {
                    file: file
                  };
                }), organisationId);

              case 6:
                assetIds = _context.sent;

                if (assetIds.length) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                newIds = [].concat(_toConsumableArray(attachmentAssetIds), _toConsumableArray(assetIds));
                onUpdateAttachments(newIds);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onRemoveAsset", function (assetId) {
      return function () {
        var _this$props2 = _this.props,
            attachmentAssetIds = _this$props2.attachmentAssetIds,
            onUpdateAttachments = _this$props2.onUpdateAttachments;
        var index = attachmentAssetIds.findIndex(function (id) {
          return id === assetId;
        });

        var newIds = _toConsumableArray(attachmentAssetIds);

        newIds.splice(index, 1);
        onUpdateAttachments(newIds);
      };
    });

    _this.state = {
      editorState: (0, _commonReact.convertToEditorState)((0, _utils.parseJson)(props.notesToTheEditor))
    };
    _this._files = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  _createClass(EditorBriefSection, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          canUpdateVideo = _this$props3.canUpdateVideo,
          organisationId = _this$props3.organisationId,
          onBlurField = _this$props3.onBlurField,
          attachmentAssetIds = _this$props3.attachmentAssetIds;
      var editorState = this.state.editorState;
      return /*#__PURE__*/_react.default.createElement(_BriefBlock.default, {
        title: "Tell us about your project",
        required: true,
        headerContent: /*#__PURE__*/_react.default.createElement(_reactFiles.default, {
          ref: this._files,
          onChange: canUpdateVideo ? this.changeFiles : void 0,
          clickable: canUpdateVideo
        }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
          type: "TERTIARY",
          prefix: "attachment",
          disabled: !canUpdateVideo
        }, "Upload Attachments"))
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "editor-brief-section__notes"
      }, /*#__PURE__*/_react.default.createElement(_commonReact.RichTextEditor, {
        editorState: editorState,
        onUpdateContent: this.onUpdateContent,
        placeholder: canUpdateVideo ? "Provide your Video Editor with essential information like:\n- Video type\n- Target audience\n- Music & video style references\n- Key message\n- etc" : 'Notes',
        disabled: !canUpdateVideo,
        organisationId: organisationId,
        onBlur: onBlurField
      })), attachmentAssetIds.length ? /*#__PURE__*/_react.default.createElement("div", {
        className: "editor-brief-section__attachments"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading5: true
      }, "Additional Attachments"), /*#__PURE__*/_react.default.createElement("div", {
        className: "editor-brief-section__attachments__grid"
      }, attachmentAssetIds.map(function (assetId) {
        return /*#__PURE__*/_react.default.createElement(_Attachment.default, {
          assetId: assetId,
          onRemoveAsset: _this2.onRemoveAsset(assetId),
          disabled: !canUpdateVideo
        });
      }))) : null);
    }
  }]);

  return EditorBriefSection;
}(_react.Component);

exports.default = EditorBriefSection;